import { Component, ComponentFactoryResolver, OnInit } from '@angular/core';
import { PageService } from '../../services/page.service';
import { UsuarioBc } from '../../model/usuario-bc';
import { AuthService } from '../../services/auth.service';
import { ToastrService } from 'ngx-toastr';
import { StorageService } from '../../services/storage.service';
import { FormasIntegracao, SistemasIntegrado, Solicitacao } from '../../model/solicitacao';
import { ConsultaService } from '../../services/consulta.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { Estabelecimento } from '../../model/estabelecimento';
import * as _ from 'underscore';
import { RespostaUsuarioCns } from '../../model/usuario-cns';
import { CrendencialModel, PortfolioSolicitadoModel } from '../../model/solicitacao-pni';
import * as moment from 'moment';
import { RespostaSistemasDisponiveis } from '../../model/resposta-sistemas-disponiveis';
import { ApiService } from '../../services/api.service';
import { Router } from '@angular/router';
import { emailValid, isValidCNES, isValidCNS } from '../../util/validation';
import { b64toBlob } from '../../util/file';
import { cep, cnpj, cns, cpf, MESES, telefone } from '../../util/format';
import { c } from '@angular/core/src/render3';
import { SistemasService } from '../../services/sistemas.service';
import * as forge from 'node-forge';
import { arrayBufferToString } from '../../util/format';
import {SolicitacoesService} from '../../services/solicitacoes.service';

@Component({
  selector: 'app-solicitacao-de-acesso',
  templateUrl: './solicitacao-de-acesso.component.html',
  styleUrls: ['./solicitacao-de-acesso.component.scss'],
})
export class SolicitacaoDeAcessoComponent implements OnInit {
  downloadFile = false;
  usuarioLogado: UsuarioBc;
  config: any;
  carregando = true;
  currentApp: any;
  cnesConsulta: string;
  cnpjConsulta: string;
  estabelecimento: Estabelecimento = new Estabelecimento();
  solicitacao: any = new Solicitacao();
  filhos = false;
  esus = false;
  sistemas = false;
  cpf: string;
  numTelefone: any;
  servicosSistema: any = [];
  isOuro:any =false;
  cns: string;
  responsavel: RespostaUsuarioCns = new RespostaUsuarioCns();
  hoje = new Date();
  esfera = 'federal';
  state: any = 0;
  municipio: any = 0;
  municipios = [];
  importer: any;
  states: any;
  est: any;
  tituloAvisoIsNotOuro = 'Atenção!';
  conteudoAvisoIsNotOuro = "Para acessar esta funcionalidade, é necessário possuir o selo ouro no Gov.br. Verifique sua autenticação para continuar.<br><br> <a href='https://www.gov.br/governodigital/pt-br/identidade/conta-gov-br/niveis-da-conta-govbr/saiba-mais-sobre-os-niveis-da-conta-govbr' target='_blank'>Saiba mais sobre os níveis da conta</a>";
  showModalAvisoAlertaIsNotOuro = false;
  esferas = {
    federal: {
      'dsEsfera': 'Esfera Municipal',
      'nuNivelEsfera': 1,
      'sgEsfera': 'FEDERAL',
      'esferaEstadualModels': null
    },
    municipal: {
      'dsEsfera': 'Esfera Municipal',
      'nuNivelEsfera': 3,
      'sgEsfera': 'MUNICIPAL',
      'esferaEstadualModels': []
    },
    estadual: {
      'dsEsfera': 'Esfera Municipal',
      'nuNivelEsfera': 2,
      'sgEsfera': 'ESTADUAL',
      'esferaEstadualModels': []
    }
  };

  showModalCertificadoCer = false;
  showModalCertificadoPfx = false;
  showModalCertificadoGerar = false;
  showModalCertificadoGerarConfirmar = false;
  showModalCertificadoRevogar = false;
  showModalRemoverCnesFilhoAlerta = false;
  showModalAdicionarEstabelecimentoFilho = false;
  showModalAdicionarSistema = false;
  showModalAdicionarPeriodo = false;
  showModalAdicionarItemPortfolio = false;
  showModalAdicionarAlerta = false;
  showModalSucesso = false;
  showModalTermo = false;
  form: any;
  subform: any;
  nuCnpjFms: string;

  servicosTodos: any;
  servicosBkp: any;
  user: any;
  termo: any;
  disable = false;
  cnpj = cnpj;
  cep = cep;
  cpfTermo = cpf;
  dia: string;
  mes: string;
  ano: string;
  nomeCessionario: string;
  cnpjCessionario: string;
  enderecoCessionario: string;
  cepCessionario: string;
  hojeTermo: any;
  nomeGestor: string;
  cpfGestor: string;
  emailGestor: string;
  telefoneGestor: string;
  nomeRepresentanteCessionario: string;
  cpfRepresentanteCessionario: string;
  telefoneRepresentanteCessionario: string;
  emailRepresentanteCessionario: string;
  currentNuCnes = null;

  searchQuery: any;
  estabFilhosAll: any[] = [];
  estabFilhosFiltered: any = [];
  estabIdSelected: any;

  currentPage = 1;
  totalPages = 1;
  limit = 0;
  range = 5;
  indexInicial: number;
  indexRange: number = 5;
  indexLimit: any;
  paginacaoList = ['5', '10', '20', '30', '40', '50'];
  pageArray = [];

  constructor(
    private pageService: PageService,
    private authService: AuthService,
    private toast: ToastrService,
    private storage: StorageService,
    private consulta: ConsultaService,
    private loading: NgxSpinnerService,
    private api: ApiService,
    private router: Router,
    private solicitacoesService: SolicitacoesService,
    private sistemasService: SistemasService
  ) {
    this.currentApp = JSON.parse(this.storage.getCurrentApp());
  }

  async ngOnInit() {
    
    try{
      this.isOuro = await this.authService.buscarConfiabilidade();
    }catch(e){

    }
    
    if(!this.isOuro){
      this.showModalAvisoAlertaIsNotOuro = true;
      return;
    }
    this.toast.toastrConfig.enableHtml = true;

    // remover, so pra apresentar msm.
    setTimeout(() => {
      this.showModalSucesso = true;
    }, 2000);

    await this.loadData();
    try {
      this.config = this.currentApp;
      this.usuarioLogado = this.authService.getUsuarioLogado();
      this.solicitacao.estabelecimentosFilhos = [];
      this.solicitacao.sistema.sistemasIntegrados = [];
      this.solicitacao.sistema.formasIntegracao = [];
      this.solicitacao.portfolioSolicitadoModel = new PortfolioSolicitadoModel();
      this.solicitacao.portfolioSolicitadoModel.servicos = [];
      this.solicitacao.sistema.periodoAcessoModel = [];
      this.loading.show();
      const resposta: RespostaSistemasDisponiveis = await this.consulta.buscarPortfolioPorId(this.config.portifolio);
      this.form = await this.sistemasService.getForm(this.config.objectId);
      this.subform = await this.sistemasService.getFormSub(this.config.objectId);
      this.loading.hide();
      this.servicosSistema = resposta.servicos;
      console.log(this.servicosSistema);
      this.solicitacao.portfolioSolicitadoModel.idPortfolioSolicitado = this.config.portifolio;
      this.solicitacao.portfolioSolicitadoModel.idPortfolio = this.config.portifolio;
      this.carregando = false;
      await this.loadCurrent();
    } catch (e) {
      console.log(e);
      //this.toast.error('Ocorreu um erro.');
      this.carregando = false;
    }
  }

  fecharModalAvisoAlertaIsOuro(data) {
    this.showModalAvisoAlertaIsNotOuro = false;
    this.router.navigateByUrl('/');

  }


  async loadData() {
    if (this.config && this.config.sigla === 'BNAFAR') {
      this.loading.show();
      const states: any = await this.api.getStates();
      this.states = states.filter(data => (data.codigoPais != null));
      this.loading.hide();
    }
  }

  async loadCurrent() {
    const solicitacao = localStorage.getItem('current-solicitacao');
    const estabelecimento = localStorage.getItem('current-estabelecimento');
    const responsavel = localStorage.getItem('current-responsavel');
    const filhos = localStorage.getItem('filhos');
    const esus = localStorage.getItem('esus');
    const sistemas = localStorage.getItem('sistemas');
    if (solicitacao) {
      this.solicitacao = JSON.parse(solicitacao);
      this.checkFilho(this.solicitacao.stEstabelecimentoFilho === 'S');
      if (this.solicitacao.stEstabelecimentoFilho === 'S') {
        await this.loadEstabFilhos();
        this.pageLimit();
      }
      this.estabelecimento = JSON.parse(estabelecimento);
      this.responsavel = JSON.parse(responsavel);
      this.esus = JSON.parse(esus);
      this.sistemas = JSON.parse(sistemas);
      this.numTelefone = telefone(this.solicitacao.solicitante.nuDdd.toString() + this.solicitacao.solicitante.nuTelefone.toString());
      if (this.config.sigla === 'BNAFAR') {
        await this.loadEsfera();
      }

      if (this.solicitacao.update && this.solicitacao.update == true) {
        this.cnesConsulta = this.solicitacao.nuCnes;
        await this.consultar();
        this.estabelecimento.email = this.solicitacao.solicitante.dsEmail;
        //this.cpf = this.solicitacao.noUsuario;

        if (this.solicitacao.sistema.formasIntegracao.length > 0) {
          this.sistemas = true;
        }

        if (this.solicitacao.sistema.dtMes) {
          this.solicitacao.sistema.dtMes = moment(this.solicitacao.sistema.dtMes).toDate();
        }

        if (this.solicitacao.sistema.operadorCadsus.nuDdd && this.solicitacao.sistema.operadorCadsus.nuTelefone) {
          this.responsavel.usuarioSUS.numTelefone = telefone(this.solicitacao.sistema.operadorCadsus.nuDdd.toString() +
          this.solicitacao.sistema.operadorCadsus.nuTelefone.toString());
        }

        this.responsavel.usuarioSUS.email = (this.solicitacao.sistema.operadorCadsus.dsEmail || '').toLowerCase();
        this.responsavel.usuarioSUS.nome = (this.solicitacao.sistema.operadorCadsus.noOperadorCadsus || '').toLowerCase();
        // await this.consultarUsuario();
        this.solicitacao.solicitante.cns = (this.solicitacao.sistema.operadorCadsus.nuCns)?cns(this.solicitacao.sistema.operadorCadsus.nuCns.toString()):'';
        this.responsavel.usuarioSUS.numeroCPF = (this.solicitacao.sistema.operadorCadsus.nuCpf)?cpf(this.solicitacao.sistema.operadorCadsus.nuCpf):'';
        this.responsavel.usuarioSUS.numeroCNS = (this.solicitacao.sistema.operadorCadsus.nuCns)?cns(this.solicitacao.sistema.operadorCadsus.nuCns.toString()):'';

        if (this.solicitacao.credencialModel && !this.solicitacao.credencialModel.nuCnpjCertificado) {
          this.solicitacao.credencialModel.nuCnpjCertificado = await this.getHash(this.solicitacao.credencialModel.dsCertificado);
        }
        //this.esus = false;
      }
    }
    this.scrollTo(1);
  }


  async loadEsfera() {
    this.loading.show();
    const states: any = await this.api.getStates();
    if (this.solicitacao.portfolioSolicitadoModel.esferaSolicitacaoModel.sgEsfera === 'FEDERAL') {
      this.esfera = 'federal';
    }
    if (this.solicitacao.portfolioSolicitadoModel.esferaSolicitacaoModel.sgEsfera === 'ESTADUAL') {
      this.esfera = 'estadual';
      const state = states.find((data) => (data.sigla ===
        this.solicitacao.portfolioSolicitadoModel.esferaSolicitacaoModel.esferaEstadualModels[0].sgEsferaEstadual));
      const municipios: any = await this.api.getMunicipio(state);
      this.municipios = municipios;
      this.state = state.codigo;
    }
    if (this.solicitacao.portfolioSolicitadoModel.esferaSolicitacaoModel.sgEsfera === 'MUNICIPAL') {
      this.esfera = 'municipal';
      const state = states.find((data) => (data.sigla ===
        this.solicitacao.portfolioSolicitadoModel.esferaSolicitacaoModel.esferaEstadualModels[0].sgEsferaEstadual));
      const municipios: any = await this.api.getMunicipio(state);
      this.municipios = municipios;
      this.state = state.codigo;
      // tslint:disable-next-line:max-line-length
      this.municipio = this.solicitacao.portfolioSolicitadoModel.esferaSolicitacaoModel.esferaEstadualModels[0].esferasMunicipais[0].coEsferaMunicipal;
    }
    this.loading.hide();
  }

  scrollTo(id) {
    const element = document.getElementById('conteudo-' + id);
    const y = element.getBoundingClientRect().top + window.pageYOffset - 60;
    window.scrollTo({ top: y, behavior: 'smooth' });

    this.menuPosition(id);
  }

  menuPosition(id) {
    const linhaMovel = document.getElementById('linha-movel');
    const menu = document.getElementById('menu-sidebar');
    const menuItem = document.getElementById('menu-' + id);
    if (menuItem == null) {
      return;
    }
    linhaMovel.style.top =
      menuItem.getBoundingClientRect().top -
      menu.getBoundingClientRect().top +
      6 +
      'px';
  }

  async fecharModalCertificadoCer(data) {
    this.showModalCertificadoCer = false;
    if (data) {
      let item =  await this.getHash(data);
      if (item != null) {
        this.downloadFile = false;
        this.solicitacao.credencialModel = new CrendencialModel();
        this.solicitacao.credencialModel.dsCertificado = data;
        this.solicitacao.credencialModel.dtInsercao = moment().format('YYYY-MM-DD');
        this.solicitacao.credencialModel.stRegistroAtivo = 'S';
        this.solicitacao.credencialModel.nuCnpjCertificado = item;
      } else {
        this.toast.error('Certificado inválido.');
      }
    }
  }

  async fecharModalCertificadoPfx(data) {
    this.showModalCertificadoPfx = false;
    if (data) {
      let item =  await this.getHash(data);
      console.log(item);
      if (item != null) {
        this.downloadFile = false;
        this.solicitacao.credencialModel = new CrendencialModel();
        this.solicitacao.credencialModel.dsCertificado = data;
        this.solicitacao.credencialModel.dtInsercao = moment().format('YYYY-MM-DD');
        this.solicitacao.credencialModel.stRegistroAtivo = 'S';
        this.solicitacao.credencialModel.nuCnpjCertificado = item;
      } else {
        this.toast.error('Certificado inválido.');
      }
    }
  }

  async fecharModalCertificadoGerar(data) {
    this.showModalCertificadoGerar = false;
    if (data.gerar) {
      this.cnesConsulta = data.retorno.coCnes;
      await this.consultar();
      this.nuCnpjFms = data.retorno.nuCnpjFms;
      this.showModalCertificadoGerarConfirmar = true;

    } else {
      console.log('data', data);
      if (data.err.error.message) {
        this.toast.error(data.err.error.message);
      }
      if (data.err.error.errorMessage.message) {
        this.toast.error(data.err.error.errorMessage.message);
      }
    }
  }

  async fecharModalCertificadoGerarConfirmar(data) {
    this.showModalCertificadoGerarConfirmar = false;

    if (data.revogar) {
      console.log('data', data);
      this.showModalCertificadoRevogar = true;
    } else {

      this.downloadFile = true;
      this.solicitacao.credencialModel = new CrendencialModel();
      this.solicitacao.credencialModel.dsCertificado = data.retorno.certificate;
      this.solicitacao.credencialModel.dtInsercao = moment().format('YYYY-MM-DD');
      this.solicitacao.credencialModel.stRegistroAtivo = 'S';
      this.solicitacao.credencialModel.nuCnpjCertificado =  await this.getHash(this.solicitacao.credencialModel.dsCertificado);

      var blob = b64toBlob(data.retorno.content, 'text/plain');

      const urlBlob = window.URL.createObjectURL(blob);
      const element = document.createElement('a');
      element.setAttribute('href', urlBlob);
      element.innerHTML = `Baixe seu certificado aqui`;
      element.setAttribute('download', `certificado_${this.nuCnpjFms}.pfx`);
      document.getElementById('cert_add').appendChild(element);
      element.click();

      this.toast.success('Certificado gerado com sucesso.');

    }
  }



  fecharModalCertificadoRevogar(data) {
    this.showModalCertificadoRevogar = false;
    if (data) {
      this.showModalCertificadoGerarConfirmar = true;
    }
  }

  async fecharModalAdicionarEstabelecimentoFilho(data) {
    this.showModalAdicionarEstabelecimentoFilho = false;
    if (data) {
      if (this.solicitacao.update && this.solicitacao.update == true) {
        this.loading.show();
        await this.solicitacoesService.postEstabFilho(this.solicitacao.id, data.nuCnes);
        await this.loadEstabFilhos();
        this.loading.hide();
      } else {
        this.solicitacao.estabelecimentosFilhos.push(data);
        if (this.solicitacao && this.solicitacao.estabelecimentosFilhos && this.solicitacao.estabelecimentosFilhos.length) {
          this.estabFilhosFiltered = Array.from(new Set([...this.estabFilhosFiltered, ...this.solicitacao.estabelecimentosFilhos]));
        }
        this.range = this.estabFilhosFiltered.length;
        this.indexRange = this.estabFilhosFiltered.length;
        this.indexLimit = this.estabFilhosFiltered.length;
      }
    }
    this.showModalRemoverCnesFilhoAlerta = false;
  }

  async fecharModalRemoveCnesFilho(data) {
    if (data == true) {
      if (this.solicitacao.update && this.solicitacao.update == true) {
        this.loading.show();
        await this.solicitacoesService.deleteEstabFilho(this.estabIdSelected);
        await this.loadEstabFilhos();
        this.loading.hide();
      } else {
        const index = this.solicitacao.estabelecimentosFilhos.findIndex((item => (item.nuCnes === this.currentNuCnes)));
        this.solicitacao.estabelecimentosFilhos.splice(index, 1);
        this.range--;
        this.indexRange--;
        this.indexLimit--;
      }
    }
    this.showModalRemoverCnesFilhoAlerta = false;
  }

  fecharModalAdicionarSistema(data) {
    this.showModalAdicionarSistema = false;
    if (data) {
      const integrado = new SistemasIntegrado();
      integrado.noSistemaIntegracao = data.noSistemaIntegracao;
      this.solicitacao.sistema.sistemasIntegrados.push(integrado);
      const formulario = new FormasIntegracao();
      formulario.noFormaIntegracao = data.noFormaIntegracao;
      this.solicitacao.sistema.formasIntegracao.push(formulario);
    }
  }

  fecharModalAdicionarPeriodo(data) {
    this.showModalAdicionarPeriodo = false;
    if (data) {
      this.solicitacao.sistema.periodoAcessoModel.push(data);
    }
  }

  fecharModalAdicionarItemPortfolio(data: any) {
    this.showModalAdicionarItemPortfolio = false;
    if (!data) {
      return;
    }

    if (!_.isArray(data) && this.solicitacao.portfolioSolicitadoModel.servicos.some((servicoOperacao) =>
      servicoOperacao.id === data.id &&
      _.intersection(
        _.map(servicoOperacao.operacaoSolicitadas, 'id'),
        _.map(data.operacaoSolicitadas, 'id')
      ).length > 0
    )) {

      this.toast.error('Serviço / operação já incluído');
      return;
    }
    if (_.isArray(data)) {
      for (let idt of data) {
        const isServiceOperationIncluded = this.solicitacao.portfolioSolicitadoModel.servicos.some((servicoOperacao) =>
          servicoOperacao.id === idt.id &&
          _.intersection(_.map(servicoOperacao.operacaoSolicitadas, 'id'), _.map(idt.operacaoSolicitadas, 'id')).length > 0
        );

        if (isServiceOperationIncluded) {
          this.toast.error('Serviço / operação já incluído');
          return;
        }
      }
    }



    if (_.isArray(data) ) {
      for(let idt of data) {
        this.solicitacao.portfolioSolicitadoModel.servicos.push(idt);
      }
    } else {
      this.solicitacao.portfolioSolicitadoModel.servicos.push(data);
    }
    if (this.currentApp.portifolio == 1 || this.currentApp.portifolio == 10) {
      this.adicionarTodos();
    }
  }

  fecharModalAdicionarAlerta(data) {
    this.showModalAdicionarAlerta = false;
  }

  fecharModalSucesso() {
    this.showModalSucesso = false;
  }

  async consultar() {
    if (this.cnesConsulta || this.cnpjConsulta) {
      this.loading.show();
      if (this.esus === true) {
        if (this.cnesConsulta) {
          this.est = await this.consulta.consultarEstabelecimentoEsusPorCNES(this.cnesConsulta);
          if (this.est) {
            this.estabelecimento = {
              sucesso: true,
              codigoCNES: this.est.coCnes,
              nomeFantasia: this.est.noFantasia,
              ddTelefone: this.est.ddTelefone,
              cep: cep(this.est.nuCep),
              descricaoEndereco: this.est.noLogradouro,
              descricaoBairro: this.est.noBairro,
              nomeMunicipio: this.est.noMunicipioAcentuado,
              siglaUF: this.est.sgUf,
              nomeEmpresarial: this.est.dsTipoUnidade,
              codigoMunicipio: this.est.coMunicipioIbge,
              codigoUF: this.est.sgUf,
              codigoUnidade: this.est.coTipoUnidade,
              mensagens: [''],
              numeroCNPJ: '',
              numero: '',
              numTelefone: '',
              email: ''
            };
          }
        }
      } else {
        if (this.cnpjConsulta) {
          this.estabelecimento = await this.consulta.consultarEstabelecimentoPorCNPJ(this.cnpjConsulta);
        } else if (this.cnesConsulta) {
          this.estabelecimento = await this.consulta.consultarEstabelecimentoPorCNES(this.cnesConsulta);
        }
      }
      this.loading.hide();
      this.solicitacao.nuCnes = '';
      this.solicitacao.solicitante.cnes = null;
      if (!this.solicitacao.solicitante.dsEmail){
        this.solicitacao.solicitante.dsEmail = '';
      }
      this.solicitacao.solicitante.noFantasia = '';
      if (!this.solicitacao.update) {
        this.solicitacao.solicitante.nuDdd = null;
        this.solicitacao.solicitante.nuTelefone = '';
      }
      this.solicitacao.solicitante.nuCnpj = '';
      this.numTelefone = '';

      if (this.config.sigla === 'BNAFAR') {
        if (this.esfera === 'estadual' && this.state === 0) {
          this.toast.error('Selecione o estado da esfera de acesso.');
          this.estabelecimento = null;
          return;
        }
        if (this.esfera === 'estadual' && Number(this.state) !== this.estabelecimento.codigoUF) {
          this.toast.error('O estado da esfera de acesso deve ser igual ao estado do CNES informado.');
          this.estabelecimento = null;
          return;
        }
        if (this.esfera === 'municipal' && this.municipio === 0) {
          this.toast.error('Selecione o municipio da esfera de acesso.');
          this.estabelecimento = null;
          return;
        }
        if (this.esfera === 'municipal' && Number(this.municipio) !== this.estabelecimento.codigoMunicipio) {
          this.toast.error('O município da esfera de acesso deve ser igual ao município do CNES informado.');
          this.estabelecimento = null;
          return;
        }
      }
      if (!this.estabelecimento) {
        this.toast.error('Esbalecimento não encontrado!');
        return;
      }
      if (this.estabelecimento.sucesso !== true) {
        this.toast.error('Nao foi possivel encontrar este estabelecimento!');
      } else {
        this.cnesConsulta = this.estabelecimento.codigoCNES;
        this.estabelecimento.numeroCNPJ = cnpj(this.estabelecimento.numeroCNPJ);
        this.estabelecimento.cep = cep(this.estabelecimento.cep);
        this.cnpjConsulta = this.estabelecimento.numeroCNPJ;
        this.solicitacao.nuCnes = this.estabelecimento.codigoCNES;
        // tslint:disable-next-line:radix
        this.solicitacao.solicitante.cnes = parseInt(this.estabelecimento.codigoCNES);
        this.estabelecimento.email = this.estabelecimento.email.toLowerCase();
        if (!this.solicitacao.solicitante.dsEmail) {
          this.solicitacao.solicitante.dsEmail = this.estabelecimento.email;
        }
        this.solicitacao.solicitante.noFantasia = this.estabelecimento.nomeFantasia;
        // tslint:disable-next-line:radix

        if (!this.solicitacao.solicitante.nuDdd) {
         this.solicitacao.solicitante.nuDdd = parseInt(this.estabelecimento.ddTelefone);
        }
        // tslint:disable-next-line:radix
        if (!this.solicitacao.solicitante.nuTelefone) {
          this.solicitacao.solicitante.nuTelefone = parseInt(this.estabelecimento.numTelefone);
        }
        this.solicitacao.solicitante.nuCnpj = this.estabelecimento.numeroCNPJ;
        console.log('this.solicitacao.solicitante---', this.solicitacao.solicitante)
        if (!this.solicitacao.solicitante.nuTelefone) {
          this.numTelefone = (this.estabelecimento.ddTelefone && this.estabelecimento.numTelefone) ? telefone(this.estabelecimento.ddTelefone.toString()+this.estabelecimento.numTelefone.toString()) : '';
        } else {
          this.numTelefone =  telefone(this.solicitacao.solicitante.nuDdd.toString() + this.solicitacao.solicitante.nuTelefone.toString());
        }
      }
    } else {
      this.toast.error('Preencha o campo CNES ou CNPJ');
    }
  }

  checkFilho(bol) {
    this.filhos = bol;
    if (!bol) {
      this.solicitacao.estabelecimentosFilhos = [];
    }
  }

  async checkEsfera(bol) {
    if (!this.solicitacao.update) {
      this.esfera = bol;
      if (this.esfera !== 'federal' && this.esfera === 'estadual') {
        if (!this.states || this.states.length === 0) {
          try {
            this.loading.show();
            this.states = await this.api.getStates();
            this.loading.hide();
          } catch (e) {
            this.loading.hide();
            this.toast.error(e);
            console.log(e);
          }
        }
      } else if (this.esfera === 'federal') {
        this.state = 0;
        this.municipio = 0;
        this.municipios = [];
      } else {
        if (this.state && this.state !== 0) {
          try {
            this.loading.show();
            const state = this.states.find((data) => (data.codigo === this.state));
            const municipios: any = await this.api.getMunicipio(state);
            this.municipios = municipios;
            this.loading.hide();
          } catch (e) {
            console.log(e);
            this.loading.hide();
            this.toast.error(e);
          }
        } else {
          if (!this.states || this.states.length === 0) {
            try {
              this.loading.show();
              this.states = await this.api.getStates();
              this.loading.hide();
            } catch (e) {
              this.loading.hide();
              this.toast.error(e);
              console.log(e);
            }
          }
        }
      }
      this.solicitacao.nuCnes = '';
      this.solicitacao.solicitante.cnes = null;
      this.solicitacao.solicitante.dsEmail = '';
      this.solicitacao.solicitante.noFantasia = '';
      this.solicitacao.solicitante.nuDdd = null;
      this.solicitacao.solicitante.nuTelefone = '';
      this.solicitacao.solicitante.nuCnpj = '';
      this.numTelefone = '';
      this.estabelecimento = null;
    }
  }

  checkEsus(bol) {
    this.esus = bol;
    this.sistemas = bol;
    if (bol === true) {
      this.solicitacao.sistema = {
        ...this.solicitacao.sistema,
        noSistemaSolicitante: 'Prontuário Eletrônico do Cidadão / e-SUS APS',
        dsSistemaSolicitante: 'O Prontuário Eletrônico do Cidadão (PEC) é um sistema de prontuário eletrônico que faz' +
          ' parte da Estratégia e-SUS APS e é distribuído pelo Ministério da Saúde.',
        stAplicacaoWeb: 'S',
        nuVersao: '4.0',
        noLinguagem: 'Java e JavaScript',
        dsArquitetura: 'RestFul',
        noBancoDeDados: 'Postgres / Oracle',
        nuVersaoBanco: 'Postgres 9.3',
        sistemasIntegrados: [
          { noSistemaIntegracao: 'CADSUS' },
          { noSistemaIntegracao: 'Hórus' },
          { noSistemaIntegracao: 'Agendamento online - ConecteSUS' },
          { noSistemaIntegracao: 'SCNES' },
          { noSistemaIntegracao: 'SIGTAP' },
        ],
        formasIntegracao: [
          { noFormaIntegracao: 'PIX/PDQ' },
          { noFormaIntegracao: 'WS' },
          { noFormaIntegracao: 'WS' },
          { noFormaIntegracao: 'Importação de arquivo' },
          { noFormaIntegracao: 'Importação de arquivo' },
        ]
      };

      this.solicitacao.nuCnes = '';
      this.solicitacao.solicitante.cnes = null;
      this.solicitacao.solicitante.dsEmail = '';
      this.solicitacao.solicitante.noFantasia = '';
      this.solicitacao.solicitante.nuDdd = null;
      this.solicitacao.solicitante.nuTelefone = '';
      this.solicitacao.solicitante.nuCnpj = '';
      this.numTelefone = '';
      this.estabelecimento = null;
      this.solicitacao.estabelecimentosFilhos = [];
      this.cnesConsulta = null;
    } else {
      this.solicitacao.sistema = {
        ...this.solicitacao.sistema,
        noSistemaSolicitante: null,
        dsSistemaSolicitante: null,
        stAplicacaoWeb: null,
        nuVersao: null,
        noLinguagem: null,
        dsArquitetura: null,
        noBancoDeDados: null,
        nuVersaoBanco: null,
        sistemasIntegrados: [],
        formasIntegracao: []
      };
      this.solicitacao.nuCnes = '';
      this.solicitacao.solicitante.cnes = null;
      this.solicitacao.solicitante.dsEmail = '';
      this.solicitacao.solicitante.noFantasia = '';
      this.solicitacao.solicitante.nuDdd = null;
      this.solicitacao.solicitante.nuTelefone = '';
      this.solicitacao.solicitante.nuCnpj = '';
      this.numTelefone = '';
      this.estabelecimento = null;
      this.solicitacao.estabelecimentosFilhos = [];
      this.cnesConsulta = null;
    }
  }

  abrirModalFilhos() {
    if (this.solicitacao.solicitante.cnes) {
      this.showModalAdicionarEstabelecimentoFilho = true;
    } else {
      this.toast.error('Preencha o campo CNES');
      this.scrollTo(2);
    }
  }

  async removerFilho(data) {
    this.estabIdSelected = data.id;
    this.showModalRemoverCnesFilhoAlerta = true;
  }

  removerSistema(data) {
    const index = this.solicitacao.sistema.sistemasIntegrados.findIndex((item => (item.noSistemaIntegracao ===
      data.noSistemaIntegracao)));
    this.solicitacao.sistema.sistemasIntegrados.splice(index, 1);
    this.solicitacao.sistema.formasIntegracao.splice(index, 1);
  }

  removerOp(data) {
    const index = this.solicitacao.portfolioSolicitadoModel.servicos.findIndex((item => (item.id === data.id)));
    this.solicitacao.portfolioSolicitadoModel.servicos.splice(index, 1);
  }

  removePeriodo(data, i) {
    this.solicitacao.sistema.periodoAcessoModel.splice(i, 1);
  }

  adicionarTodos() {
    this.solicitacao.portfolioSolicitadoModel.servicos =
      _.map(this.servicosSistema.filter((servico) => servico.noServico.toLowerCase().indexOf('pix') < 0), (data: any) => ({
        id: data.id,
        name: data.noServico,
        operacaoSolicitadas: _.map(data.operacoes, (dataOp: any) => ({
          id: dataOp.id,
          name: dataOp.noOperacao
        }))
      }));
  }

  mapItem(arr) {
    return arr.map(function (elem) {
      return elem.name;
    }).join(',');
  }

  async consultarUsuario() {
    if (this.cpf || this.cns) {
      let consulta: RespostaUsuarioCns = new RespostaUsuarioCns();
      try {

        if (this.cpf) {
          let valida = false;
          this.loading.show();
            if (this.solicitacao.nuCnes) {

              let validaUser:any = await this.consulta.validarUsuarioSUSPertenceCnes(
                this.cpf,
                this.solicitacao.nuCnes
              );
              if (!validaUser || (validaUser.sucesso == false && validaUser.mensagens.length > 0)) {
                this.loading.hide();
                this.toast.error(validaUser.mensagens.join(', '));
                return;
              }
            } else {
              this.loading.hide();
              this.toast.error('Adicione um estabelecimento pai.');
              return;
            }
          consulta = await this.consulta.consultarUsuarioSusPorCPF(
            this.cpf
          );
          this.cpf = null;
          this.loading.hide();
        } else if (this.cns) {

            if (this.solicitacao.nuCnes) {
              this.loading.show();
              let validaUser:any = await this.consulta.validarUsuarioSUSPertenceCnes(
                null,
                this.solicitacao.nuCnes,
                this.cns,
              );
              console.log('validaUser', validaUser)
              if (!validaUser || (validaUser.sucesso == false && validaUser.mensagens.length > 0)) {
                this.loading.hide();
                this.toast.error(validaUser.mensagens.join(', '));
                return;
              }
            } else {
              this.loading.hide();
              this.toast.error('Adicione um estabelecimento pai.');
              return;
            }
          consulta = await this.consulta.consultarUsuarioSusPorCNS(
            this.cns
          );

          this.loading.hide();
          this.cns = null;
        }
      } catch (e) {
        this.loading.hide();
      }

      this.responsavel = null;
      this.solicitacao.solicitante.cns = null;

      if (!consulta) {
        return;
      }
      if (consulta.sucesso !== true) {
        this.toast.error('Nao foi possivel encontrar este responsável!');
      } else {
        this.responsavel = consulta;

        this.solicitacao.solicitante.cns = cns(this.responsavel.usuarioSUS.numeroCNS);
        this.responsavel.usuarioSUS.numeroCPF = cpf(this.responsavel.usuarioSUS.numeroCPF);
        this.responsavel.usuarioSUS.numeroCNS = cns(this.responsavel.usuarioSUS.numeroCNS);
        if (!this.solicitacao.update) {
          this.responsavel.usuarioSUS.numTelefone = telefone(this.responsavel.usuarioSUS.ddTelefone.toString() +
            this.responsavel.usuarioSUS.numTelefone.toString());
          this.responsavel.usuarioSUS.email = (this.responsavel.usuarioSUS.email || '').toLowerCase();
        } else {
          if (this.solicitacao.sistema.operadorCadsus.nuDdd && this.solicitacao.sistema.operadorCadsus.nuTelefone) {
            this.responsavel.usuarioSUS.numTelefone = telefone(this.solicitacao.sistema.operadorCadsus.nuDdd.toString() +
            this.solicitacao.sistema.operadorCadsus.nuTelefone.toString());
          }
          this.responsavel.usuarioSUS.email = (this.solicitacao.sistema.operadorCadsus.dsEmail || '').toLowerCase();
          console.log('this.solicitacao', this.solicitacao)
        }
        this.cpf = this.responsavel.usuarioSUS.numeroCPF;
        this.cns = this.responsavel.usuarioSUS.numeroCNS;
      }
    } else {
      this.toast.error('Preencha o campo CNS ou CPF');
    }
  }


  continuar() {
    if (this.sistemas == false) {
      this.solicitacao.sistema.sistemasIntegrados = [];
      this.solicitacao.sistema.formasIntegracao = [];
    }
    if (this.validateForm()) {
      if (!this.showForm('Identifique o operador do CADSUS')) {
        console.log(this.solicitacao.solicitante)
        this.solicitacao.sistema.operadorCadsus = {
          dsEmail: this.responsavel.usuarioSUS.email,
          nuCnes: this.estabelecimento.codigoCNES,
          nuCns: this.solicitacao.solicitante.cns.toString().replace(/\D/g, ''),
          nuDdd: this.responsavel.usuarioSUS.ddTelefone,
          nuTelefone: this.responsavel.usuarioSUS.numTelefone.toString()
            .substr(-10, 10)
            .replace(/\D/g, ''),
          noArea: null,
          noSetor: null,
          noOperadorCadsus: this.responsavel.usuarioSUS.nome,
          nuCpf: this.responsavel.usuarioSUS.numeroCPF.toString()
        };
      }

      if (this.showForm('Esfera do acesso')) {
        const esfera = this.esferas[this.esfera];
        if (this.esfera === 'estadual') {
          const estado = this.states.find((data) => (data.codigo === this.state));
          esfera.esferaEstadualModels.push({
            'dsEsferaEstadual': estado.nome,
            'sgEsferaEstadual': estado.sigla,
            'esferasMunicipais': null
          });
        }
        if (this.esfera === 'municipal') {
          const estado = this.states.find((data) => (data.codigo === this.state));
          const municipio = this.municipios.find((data) => (data.codigo === this.municipio));
          esfera.esferaEstadualModels.push({
            'dsEsferaEstadual': estado.nome,
            'sgEsferaEstadual': estado.sigla,
            'esferasMunicipais': [
              {
                'coEsferaMunicipal': municipio.codigo,
                'dsEsferaMunicipal': municipio.nome
              }
            ]
          });
        }
        this.solicitacao.portfolioSolicitadoModel.esferaSolicitacaoModel = esfera;
      }
      if (!this.solicitacao.update) {
        localStorage.setItem('current-solicitacao', JSON.stringify(this.solicitacao));
        localStorage.setItem('current-estabelecimento', JSON.stringify(this.estabelecimento));
        localStorage.setItem('current-responsavel', JSON.stringify(this.responsavel));
        localStorage.setItem('filhos', JSON.stringify(this.filhos));
        localStorage.setItem('esus', JSON.stringify(this.esus));
        localStorage.setItem('sistemas', JSON.stringify(this.sistemas));
        localStorage.setItem('servicosPortfolio', JSON.stringify(this.servicosSistema));
        localStorage.setItem('form', JSON.stringify(this.form));
        localStorage.setItem('subform', JSON.stringify(this.subform));

        this.router.navigateByUrl('/resumo-solicitacao');
      } else {
        this.loadTerm();
      }
    }
  }

  validateForm() {
    if (this.showForm('Identifique o estabelecimento cessionário') && this.showFormSub('Certificado digital') && !this.solicitacao.update) {
      if (!this.solicitacao.credencialModel) {
        this.toast.error('Adicione um certificado digital.');
        this.scrollTo(2);
        return false;
      }
    }

    if (this.showForm('Esfera do acesso') && !this.solicitacao.update) {
      if (this.esfera !== 'federal') {
        if (this.esfera === 'estadual' && (!this.state || this.state === 0)) {
          this.toast.error('Seleciona um estado.');
          this.scrollTo('1.1');
          return false;
        }

        if (this.esfera === 'municipal' && (!this.state || this.state === 0)) {
          this.toast.error('Seleciona um estado.');
          this.scrollTo('1.1');
          return false;
        }

        if (this.esfera === 'municipal' && (!this.municipio || this.municipio === 0)) {
          this.toast.error('Seleciona um municipio.');
          this.scrollTo('1.1');
          return false;
        }
      }
    }
    if (this.showForm('Identifique o estabelecimento cessionário')) {
      if (!this.solicitacao.nuCnes) {
        this.toast.error('Preencha o estabelecimento');
        this.scrollTo(2);
        return false;
      }
      if (!this.solicitacao.solicitante.dsEmail) {
        this.toast.error('Preencha o campo e-mail');
        this.scrollTo(2);
        return false;
      }
      if (!emailValid(this.solicitacao.solicitante.dsEmail)) {
        this.toast.error('Preencha o um e-mail válido');
        this.scrollTo(2);
        return false;
      }
      if (!this.numTelefone) {
        this.toast.error('Preencha o campo telefone');
        this.scrollTo(2);
        return false;
      }
      if (this.numTelefone.length < 13) {
        console.log(this.numTelefone);
        this.toast.error('O campo telefone é inválido');
        this.scrollTo(2);
        return false;
      }
      const regexP = RegExp('^((1[1-9])|([2-9][0-9]))((3[0-9]{3}[0-9]{4})|([0-9]{4}[0-9]{5}))$');
      const number = this.numTelefone.replace(/([^\d])+/gim, '');
      const regexD = RegExp('^((1[1-9])|([2-9][0-9]))((3[0-9]{3}[0-9]{4})|([0-9]{4}[0-9]{4}))$');

      if (!regexP.test(number) && !regexD.test(number)) {
        console.log(this.numTelefone, 2);
        this.toast.error('O campo telefone é inválido');
        this.scrollTo(2);
        return false;
      }

      const telefone = this.numTelefone.split(') ');
      this.solicitacao.solicitante.nuDdd = (telefone[0].replace('(', '').trim());
      this.solicitacao.solicitante.nuTelefone = (telefone[1].replace('-', ''));
    }

    // tslint:disable-next-line:no-shadowed-variable

    if (this.showForm('Identifique o estabelecimento filho') && !this.solicitacao.update) {
      if (this.filhos === true && this.solicitacao.estabelecimentosFilhos.length === 0) {
        this.toast.error('Adicione ao menos um estabelecimento filho');
        this.scrollTo(4);
        return false;
      }
    }
    if (this.showForm('Indique o gestor responsável')) {
      if (!this.solicitacao.solicitante.cns) {
        this.toast.error('Preencha o gestor responsável');
        this.scrollTo(5);
        return false;
      }
      if (!isValidCNS(this.solicitacao.solicitante.cns)) {
        this.toast.error('Preencha o gestor responsável');
        this.scrollTo(5);
        return false;
      }
    }

    if (this.showForm('Indique o sistema solicitante')) {
      if (!this.solicitacao.sistema.noSistemaSolicitante) {
        this.toast.error('Preencha o nome do sistema');
        this.scrollTo(6);
        return false;
      }
      if (!this.solicitacao.sistema.nuVersao) {
        this.toast.error('Preencha a versao do sistema');
        this.scrollTo(6);
        return false;
      }
      if (!this.solicitacao.sistema.noLinguagem) {
        this.toast.error('Preencha a linguagem do sistema');
        this.scrollTo(6);
        return false;
      }
      if (!this.solicitacao.sistema.dsArquitetura) {
        this.toast.error('Preencha a arquitetura do sistema');
        this.scrollTo(6);
        return false;
      }
      if (!this.solicitacao.sistema.noBancoDeDados) {
        this.toast.error('Preencha o banco de dados do sistema');
        this.scrollTo(6);
        return false;
      }
      if (!this.solicitacao.sistema.nuVersaoBanco) {
        this.toast.error('Preencha a versão do banco de dados do sistema');
        this.scrollTo(6);
        return false;
      }
    }
    if (this.showForm('Descrição do sistema solicitante')) {
      if (!this.solicitacao.sistema.dsSistemaSolicitante) {
        this.toast.error('Preencha o resumo do sistema');
        this.scrollTo(7);
        return false;
      }
      if (!this.solicitacao.sistema.stAplicacaoWeb) {
        this.toast.error('Preencha o tipo do sistema');
        this.scrollTo(7);
        return false;
      }
      //if (!this.esus) {
        if (!this.solicitacao.sistema.nuIpInicial) {
          this.toast.error('Preencha o IP inicial');
          this.scrollTo(7);
          return false;
        }
        if (!this.solicitacao.sistema.nuIpFinal) {
          this.toast.error('Preencha o IP final');
          this.scrollTo(7);
          return false;
        }
      //}
      // tslint:disable-next-line:max-line-length
      const regex = RegExp('^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$');
      if (this.solicitacao.sistema.nuIpInicial && !regex.test(this.solicitacao.sistema.nuIpInicial)) {
        this.toast.error('IP inicial inválido');
        this.scrollTo(7);
        return false;
      }
      if (this.solicitacao.sistema.nuIpFinal && !regex.test(this.solicitacao.sistema.nuIpFinal)) {
        this.toast.error('IP final inválido');
        this.scrollTo(7);
        return false;
      }

      if (!this.solicitacao.sistema.stEmpresaPrivada) {
        this.toast.error('Selecione o tipo de equipe responsável');
        this.scrollTo(7);
        return false;
      }
      if (this.solicitacao.sistema.stEmpresaPrivada === 'O' && !this.solicitacao.sistema.noOutros) {
        this.toast.error('Especifique o outro tipo de equipe responsável pelo uso do serviço');
        this.scrollTo(7);
        return false;
      }
      if (!this.solicitacao.sistema.qtAtendimento) {
        this.toast.error('Preencha a quantidade de atendimento');
        this.scrollTo(7);
        return false;
      }
      if (!this.solicitacao.sistema.dtMes) {
        this.toast.error('Preencha a data do atendimento');
        this.scrollTo(7);
        return false;
      }
    }
    if (this.showForm('Integração com outros sistemas')) {
      if (this.sistemas === true && this.solicitacao.sistema.sistemasIntegrados.length === 0) {
        this.toast.error('Preencha pelo menos um sistema integrado');
        this.scrollTo(8);
        return false;
      }
    }
    if (this.showForm('Períodos de maior acesso nos sistemas')) {
      if (this.solicitacao.sistema.periodoAcessoModel.length === 0) {
        this.toast.error('Preencha pelo menos um periodo de maior acesso');
        this.scrollTo(9);
        return false;
      }
    }
    if (this.showForm('Indique o gestor responsável')) {
      if (!this.responsavel.usuarioSUS.numTelefone) {
        this.toast.error('Preencha o campo telefone');
        this.scrollTo(5);
        return false;
      }
      if (this.responsavel.usuarioSUS.numTelefone.length < 13) {
        this.toast.error('O campo telefone é inválido');
        this.scrollTo(5);
        return false;
      }
      const regexC = RegExp('^((1[1-9])|([2-9][0-9]))((3[0-9]{3}[0-9]{4})|([0-9]{4}[0-9]{5}))$');
      const numbeC = this.responsavel.usuarioSUS.numTelefone.replace(/([^\d])+/gim, '');
      const regexX = RegExp('^((1[1-9])|([2-9][0-9]))((3[0-9]{3}[0-9]{4})|([0-9]{4}[0-9]{4}))$');

      if (!regexC.test(numbeC) && !regexX.test(numbeC)) {
        this.toast.error('O campo telefone é inválido');
        this.scrollTo(5);
        return false;
      }

      if (!this.responsavel.usuarioSUS.email) {
        this.toast.error('Preencha o email');
        this.scrollTo(5);
        return false;
      }
      if (this.responsavel.usuarioSUS.email && !emailValid(this.responsavel.usuarioSUS.email)) {
        this.toast.error('Preencha o um e-mail válido');
        this.scrollTo(5);
        return false;
      }
    }

    if (this.showForm('Identifique o operador do CADSUS')) {
      if (!this.solicitacao.sistema.operadorCadsus.nuCns) {
        this.toast.error('Preencha o CNS');
        this.scrollTo(10);
        return false;
      }
      if (!this.solicitacao.sistema.operadorCadsus.dsEmail) {
        this.toast.error('Preencha o email');
        this.scrollTo(10);
        return false;
      }
      if (!emailValid(this.solicitacao.sistema.operadorCadsus.dsEmail)) {
        this.toast.error('Preencha o um e-mail válido');
        this.scrollTo(10);
        return false;
      }
      if (!this.solicitacao.sistema.operadorCadsus.nuCnes) {
        this.toast.error('Preencha o CNES');
        this.scrollTo(10);
        return false;
      }
      if (!isValidCNES(this.solicitacao.sistema.operadorCadsus.nuCnes)) {
        this.toast.error('Preencha o CNES');
        this.scrollTo(10);
        return false;
      }
      if (!this.solicitacao.sistema.operadorCadsus.nuDdd) {
        this.toast.error('Preencha o DDD');
        this.scrollTo(10);
        return false;
      }
      if (!this.solicitacao.sistema.operadorCadsus.nuTelefone) {
        this.toast.error('Preencha o telefone');
        this.scrollTo(10);
        return false;
      }
      if (!this.solicitacao.sistema.operadorCadsus.noArea) {
        this.toast.error('Preencha a área');
        this.scrollTo(10);
        return false;
      }
      if (!this.solicitacao.sistema.operadorCadsus.noSetor) {
        this.toast.error('Preencha o setor');
        this.scrollTo(10);
        return false;
      }
    }

    if (this.showForm('Selecionar portfólio')  && !this.solicitacao.update) {
      if (!this.solicitacao.portfolioSolicitadoModel.qtMinimoAcessoDia) {
        this.toast.error('Preencha a quantidade minima de atendimento');
        this.scrollTo(11);
        return false;
      }
      if (!this.solicitacao.portfolioSolicitadoModel.qtMaximoAcessoDia) {
        this.toast.error('Preencha a quantidade máxima de atendimento');
        this.scrollTo(11);
        return false;
      }
      if (!this.solicitacao.portfolioSolicitadoModel.qtAcessoPeriodoPico) {
        this.toast.error('Preencha a quantidade de acessos no período de pico');
        this.scrollTo(11);
        return false;
      }
      if (!parseInt(this.solicitacao.portfolioSolicitadoModel.qtMinimoAcessoDia.toString(), 10)) {
        this.toast.error('Quantidade minima de atendimento deve ser maior que zero');
        this.scrollTo(11);
        return false;
      }
      if (!parseInt(this.solicitacao.portfolioSolicitadoModel.qtMaximoAcessoDia.toString(), 10)) {
        this.toast.error('Quantidade máxima de atendimento deve ser maior que zero');
        this.scrollTo(11);
        return false;
      }
      if (!parseInt(this.solicitacao.portfolioSolicitadoModel.qtAcessoPeriodoPico.toString(), 10)) {
        this.toast.error('Quantidade de acessos no período de pico deve ser maior que zero');
        this.scrollTo(11);
        return false;
      }

      // Quantidades de atendimento mínimo deve ser menor que o máximo e menor ou igual ao
      // pico, o pico deve ser maior ou igual ao mínimo e menor ou igual ao máximo (imagem
      // abaixo)
      // tslint:disable-next-line:max-line-length radix
      if (parseInt(this.solicitacao.portfolioSolicitadoModel.qtMinimoAcessoDia.toString()) >= parseInt(this.solicitacao.portfolioSolicitadoModel.qtMaximoAcessoDia.toString())) {
        this.toast.error('A quantidade mínima deve ser menor que a quantidade máxima');
        this.scrollTo(11);
        return false;
      }
      // tslint:disable-next-line:radix max-line-length
      if (parseInt(this.solicitacao.portfolioSolicitadoModel.qtMinimoAcessoDia.toString()) > parseInt(this.solicitacao.portfolioSolicitadoModel.qtAcessoPeriodoPico.toString())) {
        this.toast.error('A quantidade mínima deve ser menor ou igual à quantidade de acessos no periodo de pico');
        this.scrollTo(11);
        return false;
      }
      // tslint:disable-next-line:radix max-line-length
      if (parseInt(this.solicitacao.portfolioSolicitadoModel.qtMaximoAcessoDia.toString()) < parseInt(this.solicitacao.portfolioSolicitadoModel.qtAcessoPeriodoPico.toString())) {
        this.toast.error('A quantidade máxima deve ser maior que a quantidade de acessos no periodo de pico');
        this.scrollTo(11);
        return false;
      }

      if (!this.solicitacao.portfolioSolicitadoModel.dtInicioPicoAcesso) {
        this.toast.error('Preencha a data de inicio');
        this.scrollTo(11);
        return false;
      }
      if (!this.solicitacao.portfolioSolicitadoModel.dtFimPicoAcesso) {
        this.toast.error('Preencha a data de fim');
        this.scrollTo(11);
        return false;
      }

      if (this.solicitacao.portfolioSolicitadoModel.dtInicioPicoAcesso > this.solicitacao.portfolioSolicitadoModel.dtFimPicoAcesso) {
        this.toast.error('Preencha a data de inicio deve ser menor que a data fim');
        this.scrollTo(11);
        return false;
      }

      if (this.solicitacao.portfolioSolicitadoModel.servicos.length === 0) {
        this.toast.error('Adicione ao menos um serviço');
        this.scrollTo(11);
        return false;
      }
    }
    return true;
  }

  async consultarCNSOperadorCadsus() {
    if (this.solicitacao.sistema.operadorCadsus.nuCns) {
      this.loading.show();

      const usuario = await this.consulta.consultarUsuarioSusPorCNS(this.solicitacao.sistema.operadorCadsus.nuCns);
      this.loading.hide();

      if (!usuario) {
        return;
      }
      if (usuario.sucesso !== true) {
        this.toast.error('Nao foi possivel encontrar este usuário!');
      } else {
        this.solicitacao.sistema.operadorCadsus.dsEmail = (usuario.usuarioSUS.email || '').toLowerCase();
        this.solicitacao.sistema.operadorCadsus.nuCpf = cpf(usuario.usuarioSUS.numeroCPF);
        this.solicitacao.sistema.operadorCadsus.noOperadorCadsus = usuario.usuarioSUS.nome;
      }
    } else {
      this.toast.error('Preencha o campo CNS');
    }
  }

  async consultarCNESOperadorCadsus() {
    if (this.solicitacao.sistema.operadorCadsus.nuCnes) {
      this.loading.show();
      const estabelecimento = await this.consulta.consultarEstabelecimentoPorCNES(this.solicitacao.sistema.operadorCadsus.nuCnes);
      this.loading.hide();

      if (!estabelecimento) {
        return;
      }
      if (estabelecimento.sucesso !== true) {
        this.toast.error('Nao foi possivel encontrar este estabelecimento!');
      } else {
        // tslint:disable-next-line:radix
        this.solicitacao.sistema.operadorCadsus.nuDdd = parseInt(estabelecimento.ddTelefone);
        this.solicitacao.sistema.operadorCadsus.nuTelefone = estabelecimento.numTelefone;
      }
    } else {
      this.toast.error('Preencha o campo CNES');
    }
  }

  checkOutrosSistemas(bol: boolean) {
    this.sistemas = bol;

    if (!bol) {
      return;
    }
    if (this.esus) {
      this.solicitacao.sistema.sistemasIntegrados = [
        { noSistemaIntegracao: 'CADSUS' },
        { noSistemaIntegracao: 'Hórus' },
        { noSistemaIntegracao: 'Agendamento online - ConecteSUS' },
        { noSistemaIntegracao: 'SCNES' },
        { noSistemaIntegracao: 'SIGTAP' },
      ];
      this.solicitacao.sistema.formasIntegracao = [
        { noFormaIntegracao: 'PIX/PDQ' },
        { noFormaIntegracao: 'WS' },
        { noFormaIntegracao: 'WS' },
        { noFormaIntegracao: 'Importação de arquivo' },
        { noFormaIntegracao: 'Importação de arquivo' },
      ];
    }
  }

  tratarEmailResponsavel() {
    if (!this.responsavel) {
      this.responsavel.usuarioSUS.email = null;
      return;
    }
    this.responsavel.usuarioSUS.email = this.responsavel.usuarioSUS.email.toLowerCase();
  }

  tratarEmailOperadorCadsus() {
    if (!this.solicitacao.sistema.operadorCadsus) {
      return;
    }
    this.solicitacao.sistema.operadorCadsus.dsEmail = this.solicitacao.sistema.operadorCadsus.dsEmail.toLowerCase();
  }

  tratarEmailSolicitante() {
    if (!this.solicitacao.solicitante) {
      this.solicitacao.solicitante.dsEmail = null;
      return;
    }
    this.solicitacao.solicitante.dsEmail = this.solicitacao.solicitante.dsEmail.toLowerCase();
  }

  tratarIp(control) {
    let dotIndexQt = 0;
    control.value = control.value.replace(/\./g, (s) => (++dotIndexQt > 3) ? '' : s);
  }

  async changeState() {
    this.loading.show();
    this.municipios = [];
    this.municipio = 0;
    if (this.state && this.state !== 0 && this.esfera !== 'estadual') {
      const state = this.states.find((data) => (data.codigo === this.state));
      const municipios: any = await this.api.getMunicipio(state);
      this.municipios = municipios;
    }
    this.loading.hide();
  }

  changeMunicipio() {
    this.solicitacao.nuCnes = '';
    this.solicitacao.solicitante.cnes = null;
    this.solicitacao.solicitante.dsEmail = '';
    this.solicitacao.solicitante.noFantasia = '';
    this.solicitacao.solicitante.nuDdd = null;
    this.solicitacao.solicitante.nuTelefone = '';
    this.solicitacao.solicitante.nuCnpj = '';
    this.numTelefone = '';

    this.estabelecimento = null;
  }

  changeDate() {
    if (this.config.sigla !== 'RNDS' && this.config.sigla !== 'SI-PNI' && this.config.sigla !== 'Vacinação') {
      const date = moment(this.solicitacao.portfolioSolicitadoModel.dtInicioPicoAcesso);
      if (date.isValid) {
        this.solicitacao.portfolioSolicitadoModel.dtFimPicoAcesso = date.add(10, 'year').format();
      } else {
        this.solicitacao.portfolioSolicitadoModel.dtFimPicoAcesso = null;
      }
    }
  }

  async adicionarTodosFilhoe() {
    this.loading.show();
    if (this.solicitacao.solicitante.cnes) {
      const filhos = await this.consulta.consultarEstabelecimentoEsusFilhoPorCNES(this.est);
      if (filhos) {
        for (const element of filhos) {
          if (element.coCnes !== this.est.coCnes) {
            this.solicitacao.estabelecimentosFilhos.push({
              nuCnes: element.coCnes,
              nomeFantasia: element.noFantasia,
              codigoMunicipio: element.coMunicipioIbge,
              codigoUF: element.codigoUF,
              siglaUf: element.sgUf
            });

            if (this.solicitacao.update && this.solicitacao.update == true) {
              this.indexLimit = this.estabFilhosAll.length;
              await this.loadEstabFilhos();
            } else {
              if (this.solicitacao && this.solicitacao.estabelecimentosFilhos && this.solicitacao.estabelecimentosFilhos.length) {
                this.estabFilhosFiltered = Array.from(new Set([...this.estabFilhosFiltered, ...this.solicitacao.estabelecimentosFilhos]));
              }
              this.range = this.estabFilhosFiltered.length;
              this.indexRange = this.estabFilhosFiltered.length;
              this.indexLimit = this.estabFilhosFiltered.length;
            }
          }
        }
      } else {
        this.toast.error('Estabelecimentos filhos não encontrados!');
      }
    } else {
      this.toast.error('Preencha o campo CNES');
      this.scrollTo(2);
    }

    this.loading.hide();
  }


  showForm(form) {
    if (this.form) {
      let obj = this.form.find((data) => (data.nome.trim() == form.trim()));
      if (obj && obj.ativo == true) {
        return true;
      }
    }
    return false;
  }

  showFormSub(form) {
    if (this.subform) {
      let obj = this.subform.find((data) => (data.nome.trim() == form.trim()));
      if (obj && obj.ativo == true) {
        return true;
      }
    }
    return false;
  }

  async importar() {
    if (this.solicitacao.nuCnes) {
      const upload: any = document.getElementById('arquivo');
      upload.click();
      var $self = this;
      upload.onchange = async () => {
        if (upload.files) {
          let file = upload.files[0];
          console.log(file.type);
          if (file.size >= 50000000) {
            this.toast.error('O arquivo ultrapassa o tamanho de 50MB');
            return;
          }

          file = await this.getBase64(upload.files[0]);
          let form: any = document.getElementById('xform') as HTMLInputElement;
          this.loading.show();
          const filhos = await this.consulta.consultarEstabelecimentoFilhoPorCSV({
            cnesPai: this.solicitacao.nuCnes,
            base64CsvFile: file
          });
          this.loading.hide();
          this.importer = filhos;
          const arrCnes = [];
          if (this.importer.validos.length > 0) {
            this.importer.validos.forEach(element => {
              let index = this.solicitacao.estabelecimentosFilhos.findIndex((item => (item.nuCnes == element.codigoCNES)));
              if (index == -1) {
                this.solicitacao.estabelecimentosFilhos.push({...element, nuCnes: element.codigoCNES});
                arrCnes.push(element.codigoCNES);
              }
            });
          }
          if (this.solicitacao.update && this.solicitacao.update == true) {
            this.indexLimit = this.estabFilhosAll.length;
            console.log('---------------------------> this.solicitacao.id', this.solicitacao.id);
            console.log('---------------------------> arrCnes', arrCnes);
            const body = {
              nuSolicitacao: this.solicitacao.id,
              listNuCnes: arrCnes,
            };
            await this.consulta.estabelecimentosFilhosLote(body);
            await this.loadEstabFilhos();
          } else {
            if (this.solicitacao && this.solicitacao.estabelecimentosFilhos && this.solicitacao.estabelecimentosFilhos.length) {
              this.estabFilhosFiltered = Array.from(new Set([...this.estabFilhosFiltered, ...this.solicitacao.estabelecimentosFilhos]));
            }
            this.range = this.estabFilhosFiltered.length;
            this.indexRange = this.estabFilhosFiltered.length;
            this.indexLimit = this.estabFilhosFiltered.length;
          }
        }
      };
    } else {
      this.toast.error('Adicione um estabelecimento pai.');
    }
  }

  adicionarPortifolio() {
    if (this.config.portifolio == 8 || this.config.portifolio == 13 || this.config.portifolio == 22) {
      if (!this.solicitacao.nuCnes) {
        this.showModalAdicionarAlerta = true;
        return;
      }
    }
    this.showModalAdicionarItemPortfolio = !this.showModalAdicionarItemPortfolio
  }

  private getBase64(file): Promise<any> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    });
  }

  async loadTerm () {
    this.config = this.currentApp;
    this.termo = await this.sistemasService.getTerm(this.config.objectId);
    const date = new Date();
    this.dia = date.getDate().toString();
    this.mes = MESES[ date.getMonth() ];
    this.ano = date.getFullYear().toString();
    this.hojeTermo = new Intl.DateTimeFormat('pt-BR', { year: 'numeric', month: 'long', day: '2-digit' }).format(date);
    this.nomeCessionario = this.estabelecimento.nomeEmpresarial;
    this.cnpjCessionario = this.estabelecimento.numeroCNPJ;
    this.enderecoCessionario = this.estabelecimento.descricaoEndereco;
    this.cepCessionario = this.estabelecimento.cep;
    this.nomeGestor = this.responsavel.usuarioSUS.nome;
    this.cpfGestor = this.responsavel.usuarioSUS.numeroCPF;
    this.emailGestor = this.responsavel.usuarioSUS.email;
    this.telefoneGestor = this.responsavel.usuarioSUS.numTelefone.toString();
    this.termo = this.termo.replace('{{dia}}', this.dia);
    this.termo = this.termo.replace('{{mes}}', this.mes);
    this.termo = this.termo.replace('{{ano}}', this.ano);
    this.termo = this.termo.replace('{{hoje}}', this.hojeTermo);
    this.termo = this.termo.replace('{{nomeCessionario}}', this.nomeCessionario);
    this.termo = this.termo.replace('{{nomeCessionario}}', this.nomeCessionario);
    this.termo = this.termo.replace('{{nomeCessionario}}', this.nomeCessionario);
    this.termo = this.termo.replace('{{cnpjCessionario}}', this.cnpj(this.cnpjCessionario));
    this.termo = this.termo.replace('{{enderecoCessionario}}', this.enderecoCessionario);
    this.termo = this.termo.replace('{{cepCessionario}}', this.cep(this.cepCessionario));
    this.termo = this.termo.replace('{{nomeGestor}}', this.nomeGestor);
    this.termo = this.termo.replace('{{cpfGestor}}', this.cpfTermo(this.enderecoCessionario));
    this.termo = this.termo.replace('{{emailGestor}}', this.emailGestor);
    this.termo = this.termo.replace('{{telefoneGestor}}', this.telefoneGestor);
    if (this.responsavel.usuarioSUS) {
      this.nomeRepresentanteCessionario = this.responsavel.usuarioSUS.nome;
      this.cpfRepresentanteCessionario = this.responsavel.usuarioSUS.numeroCPF;
      this.telefoneRepresentanteCessionario = this.responsavel.usuarioSUS.numTelefone.toString();
      this.emailRepresentanteCessionario = this.responsavel.usuarioSUS.email;
      if (this.nomeRepresentanteCessionario) {
        this.termo = this.termo.replace('{{nomeRepresentanteCessionario}}', this.nomeRepresentanteCessionario);
        this.termo = this.termo.replace('{{nomeRepresentanteCessionario}}', this.nomeRepresentanteCessionario);
      } else {
        this.termo = this.termo.replace('{{nomeRepresentanteCessionario}}', '-');
      }
      this.termo = this.termo.replace('{{cpfRepresentanteCessionario}}', this.cpfRepresentanteCessionario);
      this.termo = this.termo.replace('{{telefoneRepresentanteCessionario}}', this.telefoneRepresentanteCessionario);
      this.termo = this.termo.replace('{{emailRepresentanteCessionario}}', this.emailRepresentanteCessionario);
    }
    this.showModalTermo = true;
  }

  async fecharModalTermo(data) {
    this.loading.show();
    try {
      this.showModalTermo = false;
      if (data == true) {
        if (this.solicitacao.credencialModel) {
          this.solicitacao.credencial = this.solicitacao.credencialModel;
          this.solicitacao.credencial.dtInsercao = moment().format();
          delete this.solicitacao.credencialModel;
          delete this.solicitacao.credencial.stRegistroAtivo;
        }
        delete this.solicitacao.estabelecimentosFilhos;
        this.solicitacao.solicitante.nuCnpj = (this.solicitacao.solicitante.nuCnpj) ? this.solicitacao.solicitante.nuCnpj.toString().replace(/\D/g, '') : null;
        this.solicitacao.solicitante.cns = this.solicitacao.solicitante.cns.toString().replace(/\D/g, '');
        const alteracao = await this.consulta.alterarDadosServico(this.solicitacao);
        this.toast.success('Alteracao realizada com sucesso!');
        await this.router.navigateByUrl('/gerenciar-credenciais');
      }

    } catch (e) {
      this.toast.error(e.message);
    }
    this.loading.hide();
  }


  async cancelar() {
    this.router.navigateByUrl('/gerenciar-credenciais');
  }

  async getHash(dsCertify) {
    try {
      const cert = await this.consulta.extrairCertificado(dsCertify);
      if (cert.documentoCertificado) {
        return cert.documentoCertificado;
      } else {
        return null;
      }
    } catch (e) {
      //this.toast.error('Certificado inválido.');
      return null;
    }
  }

  async onRangeChange(newRange: number) {
    this.range = newRange;
    if ((this.range * this.currentPage) <= this.indexLimit) {
      this.indexRange = this.range * this.currentPage;
    } else {
      this.indexRange = this.indexLimit;
    }

    this.pageLimit();
    await this.loadEstabFilhos();
  }

  async avancaPagina() {
    if (this.currentPage < this.totalPages) {
      this.currentPage += 1;
      if ((this.range * this.currentPage) <= this.indexLimit) {
        this.indexRange = this.range * this.currentPage;
      } else {
        this.indexRange = this.indexLimit;
      }
      await this.loadEstabFilhos();
    }
  }

  async voltaPagina() {
    if (this.currentPage > 1) {
      this.currentPage -= 1;
      this.indexRange = this.range * this.currentPage;
      await this.loadEstabFilhos();
    }
  }

  async pageSelect(pagina) {
    this.currentPage = pagina;
    await this.loadEstabFilhos();
  }

  pageLimit() {
    this.pageArray = [];
    this.limit = Math.ceil(this.estabFilhosAll.length / this.range);
    for (let index = 0; index < this.limit; index++) {
      this.pageArray.push(index + 1);
    }
  }

  async searchEstab(event) {
    if (this.solicitacao.update && this.solicitacao.update == true) {
      await this.loadEstabFilhos(event);
    } else {
      if (event.length) {
        this.estabFilhosFiltered = this.solicitacao.estabelecimentosFilhos.filter((estab: any) => estab.nuCnes.includes(event));
        this.indexLimit = this.estabFilhosFiltered.length;
      } else {
        this.estabFilhosFiltered = this.solicitacao.estabelecimentosFilhos;
        this.indexLimit = this.estabFilhosFiltered.length;
      }

    }
  }

  async loadEstabFilhos(searchQuery = false) {
    this.loading.show();
    const result: any = await this.solicitacoesService.getEstabFilhos(this.solicitacao.nuSolicitacao, this.solicitacao.nuAno, this.currentPage - 1, this.range, searchQuery);
    this.estabFilhosFiltered = result.content;
    this.solicitacao.estabelecimentosFilhos = this.estabFilhosFiltered;
    this.indexLimit = result.totalElements;
    this.totalPages = result.totalPages;
    this.loading.hide();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/solicitacao-de-acesso/solicitacao-de-acesso.component.ts